import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const clearRedisKeyData = async (key) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/clear-redis-key/${key}`)
        return await response.data;
    } catch (error) {
        console.log("redis cache - error", error)
        return handleApiError(error)
    }
}